import {useFlags} from 'launchdarkly-react-client-sdk';
import {MRT_Row} from 'material-react-table';
import React from 'react';
import {type SearchDisplayCreator} from '@/types/models/creator-crm/creatorCrm';
import {isOffPlatformCreator} from '@/views/creators/creator-crm/utils/offPlatformCreator';
import VettingStatusChip from '@/components/vetting-status-chip';
import useNavigateToLatestReport from '@/hooks/use-navigate-to-latest-report';
import styles from './VettingStatusCell.module.scss';

type VettingStatusCellProps = {
  row: MRT_Row<SearchDisplayCreator>;
};

function VettingStatusCell({row}: VettingStatusCellProps) {
  const vetting = row.original.brandSafetyVetting;
  const flags = useFlags();
  const handleClick = useNavigateToLatestReport(
    row.original.id,
    flags.fifaRevamp ? 'agency' : undefined,
    'crm'
  );

  const decision = vetting?.vettingDecision;
  if (isOffPlatformCreator(row.original) || !decision) {
    return (
      <span className={styles.noData} data-testid="vetting-status-cell-empty">
        -
      </span>
    );
  }

  return (
    <div className={styles.clickable} onClick={handleClick}>
      <VettingStatusChip
        status={decision}
        decisionDate={
          vetting?.decisionUpdatedAt
            ? new Date(vetting.decisionUpdatedAt)
            : undefined
        }
        readOnly
        testID="vetting-status-cell-chip"
        className={styles.chip}
      />
    </div>
  );
}

export default VettingStatusCell;
